import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsHighlight() {
  const testimonials = [{
    initials: 'MG',
    quote: 'Organicé las viandas de toda la semana en una tarde',
    name: 'Mariela G.',
    role: 'Mamá separada',
    location: 'Buenos Aires'
  }, {
    initials: 'LP',
    quote: 'Por fin dejé de improvisar cada mañana a las 7am',
    name: 'Laura P.',
    role: 'Mamá separada',
    location: 'Ciudad de México'
  }, {
    initials: 'RM',
    quote: 'Nunca más mandé una vianda repetida sin sentido',
    name: 'Roberto M.',
    role: 'Papá separado',
    location: 'Bogotá'
  }];
  return <section className="bg-cosmic-deep pt-3 md:pt-4 pb-4 md:pb-5 px-4" data-id="element-318" data-mp="cvlcefw17z6h">
      <div className="max-w-5xl mx-auto" data-id="element-319" data-mp="ctipi4q6em5z">
        <h2 className="font-display font-bold text-center text-base md:text-lg text-white mb-2.5" data-id="element-320" data-mp="19e16g94c3mdg">
          💬 LO QUE DICEN
        </h2>
        <div className="grid md:grid-cols-3 gap-2" data-id="element-321" data-mp="14l823mcs2g1w">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl p-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gold/20 flex flex-col" data-id="element-322" data-mp="15en45rpfqoys" data-mpi={i}>
              <div className="flex items-center gap-0.5 text-gold mb-1" data-id="element-323" data-mp="vnk0ci54fvvt">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 fill-current" data-id="element-324" data-mp="10lbuzjx5hw3p" data-mpi={i} />)}
              </div>
              <p className="font-display font-semibold text-[11px] md:text-[13px] text-white leading-snug mb-1.5 flex-grow" data-id="element-325" data-mp="mq009cizw5ms">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-1.5 pt-1.5 border-t border-white/10" data-id="element-326" data-mp="cr0ovm6uhvw3">
                <div className="w-6 h-6 rounded-full bg-gradient-to-br from-[#2D0A6B] to-[#1a0533] flex items-center justify-center text-white font-bold text-[9px] shrink-0 border border-white/10" data-id="element-327" data-mp="hpc123km4ihh">
                  {t.initials}
                </div>
                <div className="text-left" data-id="element-328" data-mp="2alelitjs3lqs">
                  <div className="font-bold text-white text-[10px] leading-tight" data-id="element-329" data-mp="2am7kh8chx6yd">
                    — {t.name}
                  </div>
                  <div className="text-white/60 text-[8px] leading-tight" data-id="element-330" data-mp="25oo70anmgy7h">
                    {t.role} | {t.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}